import dashboardDashboardFunctionsHeadlineEnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-headline_en-GB.webp';
import dashboardDashboardFunctions1EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-1_en-GB.webp';
import dashboardDashboardFunctions2EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-2_en-GB.webp';
import dashboardDashboardFunctions3EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-3_en-GB.webp';
import dashboardDashboardFunctions4EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-4_en-GB.webp';
import dashboardDashboardFunctions5EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-5_en-GB.webp';
import dashboardDashboardFunctions6EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-6_en-GB.webp';
import dashboardDashboardFunctions7EnGB from '../../../../assets/images/userManual/dashboard-dashboard-functions-7_en-GB.webp';
import bookingsBookingOverview1EnGB from '../../../../assets/images/userManual/bookings-booking-overview-1_en-GB.png';
import bookingsBookingOverview2EnGB from '../../../../assets/images/userManual/bookings-booking-overview-2_en-GB.png';
import displayTransactionsTableEnGB from '../../../../assets/images/userManual/display-transactions-table_en-GB.webp';
import displayTransactionsFilterEnGB from '../../../../assets/images/userManual/display-transactions-filter_en-GB.webp';
import displayTransactionsStatusEnGB from '../../../../assets/images/userManual/display-transactions-status_en-GB.webp';
import displayTransactionsPricesEnGB from '../../../../assets/images/userManual/display-transactions-prices_en-GB.webp';
import displayTransactionsExportEnGB from '../../../../assets/images/userManual/display-transactions-export_en-GB.webp';
import servicesChargingEnGB from '../../../../assets/images/userManual/services-charging_en-GB.webp';
import servicesRepairAndMaitenance1EnGB from '../../../../assets/images/userManual/services-repairAndMaintenance-1_en-GB.webp';
import servicesRepairAndMaitenance2EnGB from '../../../../assets/images/userManual/services-repairAndMaintenance-2_en-GB.webp';
import servicesWashingEnGB from '../../../../assets/images/userManual/services-washing_en-GB.webp';
import servicesParking1EnGB from '../../../../assets/images/userManual/services-parking-1_en-GB.webp';
import servicesParking2EnGB from '../../../../assets/images/userManual/services-parking-2_en-GB.webp';
import servicesParking3EnGB from '../../../../assets/images/userManual/services-parking-3_en-GB.webp';
import servicesParking4EnGB from '../../../../assets/images/userManual/services-parking-4_en-GB.webp';
import servicesParking5EnGB from '../../../../assets/images/userManual/services-parking-5_en-GB.webp';
import servicesParking6EnGB from '../../../../assets/images/userManual/services-parking-6_en-GB.webp';
import servicesMobileFuelling1EnGB from '../../../../assets/images/userManual/services-mobileFuelling-1_en-GB.webp';
import servicesMobileFuelling2EnGB from '../../../../assets/images/userManual/services-mobileFuelling-2_en-GB.webp';
import servicesMobileFuelling3EnGB from '../../../../assets/images/userManual/services-mobileFuelling-3_en-GB.webp';
import servicesMobileFuelling4EnGB from '../../../../assets/images/userManual/services-mobileFuelling-4_en-GB.webp';
import driverAppTeaser from '../../../../assets/images/userManual/driver-app-teaser.webp';

import manAppIcon from '../../../../assets/images/userManual/man-app-icon.png';
import manAppleStoreQr from '../../../../assets/images/userManual/man-apple-store-qr.png';
import manPlayStoreQr from '../../../../assets/images/userManual/man-play-store-qr.png';
import playStore from '../../../../assets/images/userManual/play-store.svg';
import appStore from '../../../../assets/images/userManual/app-store.svg';
import { DEFAULT_LOCALE, MANUAL_IMAGE_LOCALES } from '../../../../i18n/locale';

/**
 * Theme and locale aware images, resolved automatically from the filesystem
 * Relies on Vite's `import.meta.glob`
 */
const imageUrls = import.meta.glob<string>(
  '../../../../assets/images/userManual/*_*_*.webp',
  { eager: true, query: '?url', import: 'default' },
);

/*
 Registry of base names for themed/localized images
 Key values should be unique
*/
export const imageBaseNames = {
  getStarted_welcome: 'get-started-welcome',
  getStarted_getStarted_step1: 'get-started-get-started-step-1',
  getStarted_getStarted_step2: 'get-started-get-started-step-2',
  getStarted_getStarted_step3: 'get-started-get-started-step-3',
  getStarted_getStarted_step4: 'get-started-get-started-step-4',
  getStarted_getStarted_step5: 'get-started-get-started-step-5',
  getStarted_overview_overview: 'get-started-overview-overview',
  getStarted_overview_quickActions: 'get-started-overview-quick-actions',
  getStarted_overview_yourInsights: 'get-started-overview-your-insights',
  getStarted_overview_ourPartners: 'get-started-overview-our-partners',
  getStarted_overview_resources: 'get-started-overview-resources',
  cardManagement_vehicleOverview_tableFilters:
    'card-management-vehicle-overview-table-filters',
  cardManagement_vehicleOverview_services:
    'card-management-vehicle-overview-services',
  cardManagement_vehicleOverview_vehicle_configuration:
    'card-management-vehicle-overview-vehicle-configuration',
  cardManagement_addingCards_vehicle_configuration:
    'card-management-adding-cards-vehicle-configuration',
  cardManagement_addingCards_newCard: 'card-management-adding-cards-new-card',
  cardManagement_addingCards_editServices:
    'card-management-adding-cards-edit-services',
  cardManagement_addingCards_failedCard:
    'card-management-adding-cards-failed-card',
  cardManagement_addingCards_deletionConfirmation:
    'card-management-adding-cards-deletion-confirmation',
  cardManagement_activatingServices_vehicleConfiguration:
    'card-management-activating-services-vehicle-configuration',
  cardManagement_activatingServices_services:
    'card-management-activating-services-services',
  cardManagement_activatingServices_removeService:
    'card-management-activating-services-remove-service',
} as const;

export type ImageBaseNames =
  (typeof imageBaseNames)[keyof typeof imageBaseNames];

// Resolves a themed/localized user-manual image
export const getManualImageAsset = (
  baseName: ImageBaseNames,
  locale = DEFAULT_LOCALE,
  darkMode: boolean,
): string => {
  if (!MANUAL_IMAGE_LOCALES.includes(locale)) {
    locale = DEFAULT_LOCALE;
  }

  const theme = darkMode ? 'dark' : 'light';
  const path = `../../../../assets/images/userManual/${baseName}_${locale}_${theme}.webp`;
  const match = imageUrls[path];
  if (!match) {
    throw new Error(`No user-manual image found at "${path}".`);
  }
  return match;
};

export const imageKeys = {
  dashboardDashboardFunctionsHeadline: 'dashboardDashboardFunctionsHeadline',
  dashboardDashboardFunctions1: 'dashboardDashboardFunctions1',
  dashboardDashboardFunctions2: 'dashboardDashboardFunctions2',
  dashboardDashboardFunctions3: 'dashboardDashboardFunctions3',
  dashboardDashboardFunctions4: 'dashboardDashboardFunctions4',
  dashboardDashboardFunctions5: 'dashboardDashboardFunctions5',
  dashboardDashboardFunctions6: 'dashboardDashboardFunctions6',
  dashboardDashboardFunctions7: 'dashboardDashboardFunctions7',
  bookingsBookingOverview1: 'bookingsBookingOverview1',
  bookingsBookingOverview2: 'bookingsBookingOverview2',
  servicesCharging: 'servicesCharging',
  servicesRepairAndMaintenance1: 'servicesRepairAndMaintenance1',
  servicesRepairAndMaintenance2: 'servicesRepairAndMaintenance2',
  servicesWashing: 'servicesWashing',
  servicesParking1: 'servicesParking1',
  servicesParking2: 'servicesParking2',
  servicesParking3: 'servicesParking3',
  servicesParking4: 'servicesParking4',
  servicesParking5: 'servicesParking5',
  servicesParking6: 'servicesParking6',
  servicesMobileFuelling1: 'servicesMobileFuelling1',
  servicesMobileFuelling2: 'servicesMobileFuelling2',
  servicesMobileFuelling3: 'servicesMobileFuelling3',
  servicesMobileFuelling4: 'servicesMobileFuelling4',
  driverAppTeaser: 'driverAppTeaser',
  displayTransactionsTable: 'displayTransactionsTable',
  displayTransactionsFilter: 'displayTransactionsFilter',
  displayTransactionsStatus: 'displayTransactionsStatus',
  displayTransactionsPrices: 'displayTransactionsPrices',
  displayTransactionsExport: 'displayTransactionsExport',
  manAppIcon: 'manAppIcon',
  manAppleStoreQr: 'manAppleStoreQr',
  manPlayStoreQr: 'manPlayStoreQr',
  playStore: 'playStore',
  appStore: 'appStore',
} as const;

export const getImageAssetWithLocale = (
  imageKey: keyof typeof imageKeys,
  locale: string,
): string => {
  const imagesGerman = {
    dashboardDashboardFunctionsHeadline:
      dashboardDashboardFunctionsHeadlineEnGB,
    dashboardDashboardFunctions1: dashboardDashboardFunctions1EnGB,
    dashboardDashboardFunctions2: dashboardDashboardFunctions2EnGB,
    dashboardDashboardFunctions3: dashboardDashboardFunctions3EnGB,
    dashboardDashboardFunctions4: dashboardDashboardFunctions4EnGB,
    dashboardDashboardFunctions5: dashboardDashboardFunctions5EnGB,
    dashboardDashboardFunctions6: dashboardDashboardFunctions6EnGB,
    dashboardDashboardFunctions7: dashboardDashboardFunctions7EnGB,
    bookingsBookingOverview1: bookingsBookingOverview1EnGB,
    bookingsBookingOverview2: bookingsBookingOverview2EnGB,
    servicesCharging: servicesChargingEnGB,
    servicesRepairAndMaintenance1: servicesRepairAndMaitenance1EnGB,
    servicesRepairAndMaintenance2: servicesRepairAndMaitenance2EnGB,
    servicesWashing: servicesWashingEnGB,
    servicesParking1: servicesParking1EnGB,
    servicesParking2: servicesParking2EnGB,
    servicesParking3: servicesParking3EnGB,
    servicesParking4: servicesParking4EnGB,
    servicesParking5: servicesParking5EnGB,
    servicesParking6: servicesParking6EnGB,
    servicesMobileFuelling1: servicesMobileFuelling1EnGB,
    servicesMobileFuelling2: servicesMobileFuelling2EnGB,
    servicesMobileFuelling3: servicesMobileFuelling3EnGB,
    servicesMobileFuelling4: servicesMobileFuelling4EnGB,
    driverAppTeaser,
    displayTransactionsTable: displayTransactionsTableEnGB,
    displayTransactionsFilter: displayTransactionsFilterEnGB,
    displayTransactionsStatus: displayTransactionsStatusEnGB,
    displayTransactionsPrices: displayTransactionsPricesEnGB,
    displayTransactionsExport: displayTransactionsExportEnGB,
    manAppIcon,
    manAppleStoreQr,
    manPlayStoreQr,
    playStore,
    appStore,
  };
  const imagesEnglish = {
    dashboardDashboardFunctionsHeadline:
      dashboardDashboardFunctionsHeadlineEnGB,
    dashboardDashboardFunctions1: dashboardDashboardFunctions1EnGB,
    dashboardDashboardFunctions2: dashboardDashboardFunctions2EnGB,
    dashboardDashboardFunctions3: dashboardDashboardFunctions3EnGB,
    dashboardDashboardFunctions4: dashboardDashboardFunctions4EnGB,
    dashboardDashboardFunctions5: dashboardDashboardFunctions5EnGB,
    dashboardDashboardFunctions6: dashboardDashboardFunctions6EnGB,
    dashboardDashboardFunctions7: dashboardDashboardFunctions7EnGB,
    bookingsBookingOverview1: bookingsBookingOverview1EnGB,
    bookingsBookingOverview2: bookingsBookingOverview2EnGB,
    servicesCharging: servicesChargingEnGB,
    servicesRepairAndMaintenance1: servicesRepairAndMaitenance1EnGB,
    servicesRepairAndMaintenance2: servicesRepairAndMaitenance2EnGB,
    servicesWashing: servicesWashingEnGB,
    servicesParking1: servicesParking1EnGB,
    servicesParking2: servicesParking2EnGB,
    servicesParking3: servicesParking3EnGB,
    servicesParking4: servicesParking4EnGB,
    servicesParking5: servicesParking5EnGB,
    servicesParking6: servicesParking6EnGB,
    servicesMobileFuelling1: servicesMobileFuelling1EnGB,
    servicesMobileFuelling2: servicesMobileFuelling2EnGB,
    servicesMobileFuelling3: servicesMobileFuelling3EnGB,
    servicesMobileFuelling4: servicesMobileFuelling4EnGB,
    driverAppTeaser,
    displayTransactionsTable: displayTransactionsTableEnGB,
    displayTransactionsFilter: displayTransactionsFilterEnGB,
    displayTransactionsStatus: displayTransactionsStatusEnGB,
    displayTransactionsPrices: displayTransactionsPricesEnGB,
    displayTransactionsExport: displayTransactionsExportEnGB,
    manAppIcon,
    manAppleStoreQr,
    manPlayStoreQr,
    playStore,
    appStore,
  };

  if (locale === 'de-DE') {
    return imagesGerman[imageKey];
  } else {
    return imagesEnglish[imageKey];
  }
};
